import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function InvoicesSettingsPage() {
  return (
    <MainLayout>
      <SEO 
        title="Configurar notas fiscais"
        description="Configure notas fiscais de serviços"
        keywords="notas fiscais, configuração, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Configurar notas fiscais</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

